// MCHD Room Scheduler - Navigation Item Component
// Individual navigation item with proper styling and interactions

import { NavigationItem } from '../../../config/navigation';
import classes from './Navbar.module.css';

/**
 * Props for the NavbarItem component
 */
interface NavbarItemProps {
  item: NavigationItem;
  isActive: boolean;
  onClick: () => void;
}

/**
 * Individual navigation item component
 * 
 * @param item - Navigation item configuration
 * @param isActive - Whether the item is currently active
 * @param onClick - Click handler function
 * @returns JSX element
 */
export function NavbarItem({ item, isActive, onClick }: NavbarItemProps): JSX.Element {
  const IconComponent = item.icon;

  return (
    <a
      className={classes.link}
      data-active={isActive || undefined}
      href={item.link}
      onClick={(event) => {
        event.preventDefault();
        onClick();
      }}
      title={item.description}
    >
      <IconComponent className={classes.linkIcon} stroke={1.5} />
      <span>{item.label}</span>
    </a>
  );
}
